/*************************************************/
/* 3rd Party                                     */
/*************************************************/
window.$ = window.jQuery = require("jquery");
import { mmenu } from "./partials/mmenu.js";

/*************************************************/
/* Vue                                           */
/*************************************************/
import Vue from "vue";
import VueRouter from "vue-router";
import Cases from "./vue/cases.vue";

const appCases = "#app-cases";
if (document.querySelectorAll(appCases).length) {

    const router = new VueRouter({
        mode: "history"
    });
    Vue.use(VueRouter);

    if (document.querySelectorAll(appCases).length) {
        var casesPageId = document.querySelector(appCases).dataset.casespage;
        var cases = new Vue({
            el: appCases,
            data: {
                casesPageId: casesPageId
            },
            render: h => h(Cases),
            router
        });
    }
}

/*************************************************/
/* Partials                                      */
/*************************************************/
import { intersectionObservation } from "./partials/intersectionObservation.js";
import { stickySidebar } from "./partials/stickySidebar.js";
import { news } from "./partials/news.js";
import { video } from "./partials/video.js";
import { header } from "./partials/header.js";
import { language } from "./partials/language.js";
import { slider } from "./partials/slider.js";
import { sliders } from "./partials/slider.js";
import { accordion } from './partials/accordion.js';
import { accordionOld } from './partials/accordion.js';
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { cookies } from "./partials/cookies.js";
import { modal } from "./partials/modal.js";
import { menu } from "./partials/menu.js";


/*************************************************/
/* Global variables                              */
/*************************************************/
const $body = $("body"),
    bodyLoadingClass = "is-loading",
    currentCulture = $("html").attr("lang");

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const body = document.querySelector('body');

    //Handle scroll to submitted form element
    const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
    if (formSubmittedElement) {
        // console.log();
        window.scrollTo(0, formSubmittedElement.closest('.form-item').getBoundingClientRect().top + window.pageYOffset);
    }

    //Fire dataLayer event for forms submission
    const formSubmitMessage = document.querySelector('[class^="umbraco-forms-submitmessage"]');
    if (formSubmitMessage) {
        window.dataLayer.push({
            'event': 'formSubmission',
            'formType': formSubmitMessage.dataset.formName
        });
    }

    mmenu();
    intersectionObservation();
    stickySidebar();
    news($body, bodyLoadingClass, currentCulture);
    video();
    header(body);
    language();
    slider();
    sliders();
    accordion();
    accordionOld();
    search();
    searchbar($body);
    cookies();
    menu();
    modal($body, bodyLoadingClass);

    $('.image-item__materials > select').change(function () {
        var url = $(this).val();
        window.location.href = url;
    });
});